import { ToggleRouterService } from '../toggle-router.service';

/**
 * @ignore
 */
export class TogglePointFunctionHelper {
  public static toggleRouterService: ToggleRouterService = undefined;
}

export function initialize(service: ToggleRouterService) {
  return () => {
    TogglePointFunctionHelper.toggleRouterService = service;
  };
}
